import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_17'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_17',
  name: 'Does the facility have any of the following safety measures in place regarding canteen / eating areas?',
  description: 'The below options apply to onsite canteens. Some options also apply to eating areas. ',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CANTEEN_EATING_AREAS_ARE_SEPARATE_FROM_THE_PRODUCTION_AREAS_EVE',
      text: 'Canteen/ eating areas are separate from the production areas (even though they may be in the same compound/ industrial park)',
      externalIds: [
        {
          id: 'hs-56--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CANTEEN_EATING_AREAS_ARE_PROTECTED_FROM_THE_ELEMENTS_AND_PROVID',
      text: 'Canteen / eating areas are protected from the elements and provide adequate seating, tables and lighting',
      externalIds: [
        {
          id: 'hs-56--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FOOD_PREPARATION_STORAGE_AND_EATING_AREAS_ARE_KEPT_CLEAN_SAFE_A',
      text: 'Food preparation, storage, and eating areas are kept clean, safe, and hygienic (including temperature, ventilation, light, noise etc.)',
      externalIds: [
        {
          id: 'hs-56--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FOOD_IS_PREPARED_IN_A_MANNER_THAT_REDUCES_THE_POTENTIAL_FOR_FOO',
      text: 'Food is prepared in a manner that reduces the potential for foodborne illnesses',
      externalIds: [
        {
          id: 'hs-56--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FOOD_SERVICE_WORKERS_RECEIVE_ANNUAL_MEDICAL_EXAMINATIONS_TO_ENS',
      text: 'Food service workers receive annual medical examinations to ensure they are healthy and free from communicable diseases',
      externalIds: [
        {
          id: 'hs-56--2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FOOD_SERVICE_WORKERS_HANDLING_FOOD_ARE_TRAINED_ABOUT_AND_FOLLOW',
      text: 'Food service workers handling food are trained about and follow food safety and proper hygiene rules',
      externalIds: [
        {
          id: 'hs-56--2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-56--2-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CANTEEN_EATING_AREAS_ARE_SEPARATE_FROM_THE_PRODUCTION_AREAS_EVE',
                'CANTEEN_EATING_AREAS_ARE_PROTECTED_FROM_THE_ELEMENTS_AND_PROVID',
                'FOOD_PREPARATION_STORAGE_AND_EATING_AREAS_ARE_KEPT_CLEAN_SAFE_A',
                'FOOD_IS_PREPARED_IN_A_MANNER_THAT_REDUCES_THE_POTENTIAL_FOR_FOO',
                'FOOD_SERVICE_WORKERS_RECEIVE_ANNUAL_MEDICAL_EXAMINATIONS_TO_ENS',
                'FOOD_SERVICE_WORKERS_HANDLING_FOOD_ARE_TRAINED_ABOUT_AND_FOLLOW',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-can-1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17470,
  sectionId: '2.2.9.11',
  impactArea: 'Canteens',
  impactAreaId: 'CANTEENS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
